// extracted by mini-css-extract-plugin
export default {"noPadding":"styles_noPadding__z6boJ","centerContent":"styles_centerContent__Dzk6P","loading":"styles_loading__98j7+"};